<div fxLayout="row nowrap" fxLayoutAlign="start stretch" top>
	<button
		class="expension-btn"
		mat-icon-button
		fxFlex
		top-title
		(click)="toggle()"
		[attr.aria-label]="expanded ? 'Click to collapse scan properties' : 'Click to expand scan properties'"
		aria-controls="body"
		disableRipple
		[matTooltip]="expanded ? 'Click to Collapse' : 'Click to Expand'">
		<ng-container [ngTemplateOutlet]="title"></ng-container>
		<mat-icon [svgIcon]="expanded ? 'expand_less' : 'expand_more'"></mat-icon>
	</button>
	<div>
		<ng-container [ngTemplateOutlet]="menu"></ng-container>
	</div>
</div>
<div *ngIf="expanded" [@expandCollapse]="expanded ? 'open' : 'close'" body id="body">
	<mat-divider></mat-divider>
	<ng-container [ngTemplateOutlet]="body"></ng-container>
</div>

<!-- content for outlets -->
<ng-template #title>
	<ng-content select="cr-expansion-panel-title"></ng-content>
</ng-template>

<ng-template #menu>
	<ng-content select="cr-expansion-panel-menu"></ng-content>
</ng-template>
<ng-template #body>
	<ng-content select="cr-expansion-panel-body"></ng-content>
</ng-template>
